import { render } from "./footerMenuSection.vue?vue&type=template&id=2c94b8c4"
import script from "./footerMenuSection.vue?vue&type=script&lang=js"
export * from "./footerMenuSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__